
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item
            label="关键字："
          >
            <el-input
              v-model="searchForm.keyWord"
              placeholder="请输入查询关键字"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>
          <div
            class="btn-box"
            style="float: right;"
          >
            <el-form-item>
              <el-button
                type="primary"
                size="small"
                @click="handleAdd"
              >
                新增
                <i class="el-icon-plus el-icon--right" />
              </el-button>
            </el-form-item>
            <el-form-item>
              <upload-excel-component
                style="display:inline;"
                :on-success="handleImportSuccess"
                :before-upload="handleBeforeUpload"
              />
            </el-form-item>
            <el-form-item>
              <el-button
                style="margin-left: 8px"
                size="small"
                type="primary"
                @click="handleExport()"
              >
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" />

      <!-- 项目名称 -->
      <el-table-column
        prop="xiangMuMingCheng"
        label="项目名称"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.xiangMuMingCheng }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.xiangMuMingCheng"
              prop="xiangMuMingCheng"
              size="small"
              placeholder="请输入项目名称"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 申请人 -->
      <el-table-column
        prop="shenQingRen"
        label="申请人"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.shenQingRen }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.shenQingRen"
              prop="shenQingRen"
              size="small"
              placeholder="请输入申请人"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 依托单位 -->
      <el-table-column
        prop="yiTuoDanWei"
        label="依托单位"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.yiTuoDanWei }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.yiTuoDanWei"
              prop="yiTuoDanWei"
              size="small"
              placeholder="请输入依托单位"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 申请金额 -->
      <el-table-column
        prop="shenQingJinE"
        label="申请金额"
        width="100"
        sortable="custom"
        align="right"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.shenQingJinE | decFmt }}</span>
            <el-input-number
              v-if="scope.row.isEdit"
              v-model="scope.row.shenQingJinE"
              size="small"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 评分 -->
      <el-table-column
        prop="pingFen"
        label="评分"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.pingFen }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.pingFen"
              prop="pingFen"
              size="small"
              placeholder="请输入评分"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 评阅意见 -->
      <el-table-column
        prop="pingYueYiJian"
        label="评阅意见"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.pingYueYiJian }}</span>
            <el-input
              v-if="scope.row.isEdit"
              v-model="scope.row.pingYueYiJian"
              prop="pingYueYiJian"
              size="small"
              placeholder="请输入评阅意见"
            />
          </div>
        </template>
      </el-table-column>

      <!-- 是否资助 -->
      <el-table-column
        prop="shiFoZiZhuDictKey"
        label="是否资助"
        width="150"
        sortable="custom"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.shiFoZiZhuDictKeyItemName }}</span>
            <el-select
              v-if="scope.row.isEdit"
              v-model="scope.row.shiFoZiZhuDictKey"
              clearable
              filterable
              placeholder="请选择是否资助"
              size="small"
            >
              <el-option
                v-for="item in getComboxData('D16')"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </template>
      </el-table-column>
      <!-- 评阅时间 -->
      <el-table-column prop="pingYueShiJian" label="评阅时间" width="160" sortable="custom" align="center">
        <template slot-scope="scope">
          <div>
            <span v-if="!scope.row.isEdit">{{ scope.row.pingYueShiJian | dateFmt }}</span>
            <el-date-picker
              v-if="scope.row.isEdit"
              v-model="scope.row.pingYueShiJian"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="请选择评阅时间"
              style="width: 100%;"
              size="small"
            />
          </div>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isEdit"
            type="text"
            size="mini"
            plain
            @click.stop="handleEdit( scope.row,scope.$index)"
          >
            修改
          </el-button>
          <el-button
            v-if="scope.row.isEdit"
            type="text"
            size="small"
            @click.stop="handleSave(scope.row)"
          >
            保存
          </el-button>
          <el-button
            v-if="scope.row.isEdit"
            type="text"
            size="small"
            @click.stop="handleCancel(scope.row ,scope.$index)"
          >
            取消
          </el-button>
          <el-button
            v-if="!scope.row.isEdit"
            type="text"
            size="mini"
            @click.stop="handleDel(scope.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <ShowUpload
      v-model="uploadFormShow"
      :upload-data="uploadData"
      @save-success="handleSearch"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import ShowUpload from './ShowUpload'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import KxjCom from '@/utils/kxjcom'
export default {
  components: {
    ShowUpload,
    UploadExcelComponent
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'xs0202',
      parentId: null,
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        parentId: null,
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: ''
      },
      uploadData: [],
      uploadFormShow: false
    }
  },

  // 初期化数据
  created() {
    // 绑定检索
    this.$bus.$off('handleInitxs0202')
    this.$bus.$on('handleInitxs0202', this.init)

    this.handleSearch()
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D16').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    /** 初始化 */
    init() {
      this.parentId = this.$route.params.id
      this.searchForm.parentId = this.$route.params.id
      if (!this.parentId) {
        this.$router.go(-1)
      }
      this.handleSearch()
    },
    // 新增
    handleAdd() {
      const dataNew = {
        id: null,
        parentId: this.parentId,
        isEdit: true,
        canBeEdit: true,
        isCanBeEdit: true
      }
      this.tableData.unshift(dataNew)
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/xs0202/GetPagedListxs0202s'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    // 编辑
    handleEdit(row) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].isEdit) {
          if (this.tableData[i].id) {
            this.tableData[i].isEdit = false
          } else {
            this.tableData.splice(i, 1)
            i--
          }
        }
        row.isEdit = true
      }
    },
    // 取消
    handleCancel(row, index) {
      row.isEdit = false
      if (!row.id) {
        this.tableData.splice(index, 1)
      }
    },
    // 删除
    handleDel(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/xs0202/Deletexs0202'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    // 新建或修改信息就是保存的时候
    handleSave(row) {
      if (!row.xiangMuMingCheng) {
        this.$message.error('请输入项目名称')
        return false
      }

      // 共通保存
      KxjCom.saveRowEntity(this.moduleCode, row, this.handleSearch)
    },
    // 只能查看
    handleShowDetail(row, index) {
      console.log(row)
      console.log(index)
      alert('转到查看画面')
    },
    /**
     * 显示课程信息
     */
    handleToDtl(id) {
      this.$router.push({
        name: 'xs0202dtl',
        params: {
          id: id,
          moduleCode: this.moduleCode
        }
      })
    },
    // 导入
    handleBeforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (isLt5M) {
        return true
      }
      this.$message.warning('数据超过5M')
      return false
    },
    handleImportSuccess({ results, header }) {
      const filterVal = [
        'parentId',
        'xiangMuMingCheng',
        'shenQingRen',
        'yiTuoDanWei',
        'shenQingJinE',
        'pingFen',
        'pingYueYiJian',
        'shiFoZiZhuDictKey',
        'pingYueShiJian'
      ]
      const data = KxjCom.formatJson(header, results)
      var b = []
      for (var i = 0; i < data.length; i++) {
        b.push(KxjCom.formatObj(filterVal, data[i]))
      }
      this.uploadData = b
      for (const row of this.uploadData) {
        row.parentId = this.parentId
        row.shiFoZiZhuDictKey = KxjCom.getComboxKeyByText(row.shiFoZiZhuDictKey, this.getComboxData('D16'))
      }

      this.uploadFormShow = true
    },

    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          'ParentId',
          '项目名称',
          '申请人',
          '依托单位',
          '申请金额',
          '评分',
          '评阅意见',
          '是否资助',
          '评阅时间'
        ]
        const filterVal = [
          'parentId',
          'xiangMuMingCheng',
          'shenQingRen',
          'yiTuoDanWei',
          'shenQingJinE',
          'pingFen',
          'pingYueYiJian',
          'shiFoZiZhuDictKeyItemName',
          'pingYueShiJianShow'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '项目清单', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    },
    /** 项目认领 */
    handleGetFromOther() {
      this.renLingShow = true
    }

  }
}
</script>

<style scoped>
/* ffc059 */
</style>
